import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setMessage } from "../slices/message";
import { setAuth } from "../slices/auth";
import { BASE_URL } from "./common";

export const userApi = createApi({
  reducerPath: "usersApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = getState().auth.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/backdoor/authenticate",
        method: "POST",
        body: credentials,
      }),
      async onQueryStarted(credentials, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setAuth(data));
        } catch (err) {
          const msg =
            (err && err.error && err.error.data && err.error.data.message) ||
            "An error has occurred when signing in.";
          dispatch(
            setMessage({ text: msg, error: JSON.stringify(err, null, 2) })
          );
        }
      },
    }),
    updateUserInfo: builder.mutation({
      query: ({ userId, userInfo }) => ({
        url: `/api/users/${userId}`,
        method: "PUT",
        body: userInfo,
      }),
      transformResponse: (response, meta, arg) => response.data,
      async onQueryStarted({ userId, userInfo }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setAuth({ userInfo: data }));
          const msg = "Successfully updated your profile information.";
          dispatch(setMessage({ text: msg }));
        } catch (err) {
          const msg =
            (err && err.error && err.error.data && err.error.data.message) ||
            "An error has occurred when submitting your profile data.";
          dispatch(
            setMessage({ text: msg, error: JSON.stringify(err, null, 2) })
          );
        }
      },
    }),
  }),
});

export const { useLoginMutation, useUpdateUserInfoMutation } = userApi;
